/**
 * Deposit values are stored and calculated as positive magnitudes. Whenever a
 * deposit item is shown as a POS line, it is rendered as a negative amount.
 */
export function formatCurrencyAmount(cents: number, currency: string) {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(
    cents / 100,
  );
}

export function formatDepositAmount(cents: number, currency: string) {
  return formatCurrencyAmount(-Math.abs(cents), currency);
}

export function formatAmountInput(cents: number) {
  return (Math.abs(cents) / 100).toFixed(2).replace(".", ",");
}

export function formatDepositAmountInput(cents: number) {
  return `-${formatAmountInput(cents)}`;
}

export function parseAmountInput(value: string, maximumCents: number) {
  const normalized = value.trim().replace(",", ".");
  if (!/^\d*(?:\.\d{0,2})?$/.test(normalized) || normalized === "") return null;

  return parseMagnitude(normalized, maximumCents);
}

export function parseDepositAmountInput(value: string, maximumCents: number) {
  const normalized = value.trim().replace(",", ".");
  if (!/^-?\d*(?:\.\d{0,2})?$/.test(normalized) || normalized === "")
    return null;

  return parseMagnitude(normalized.replace(/^-/, ""), maximumCents);
}

function parseMagnitude(value: string, maximumCents: number) {
  const [whole = "0", fraction = ""] = value.split(".");
  const cents =
    Number(whole || "0") * 100 + Number(fraction.padEnd(2, "0") || "0");
  return Number.isSafeInteger(cents) && cents >= 1 && cents <= maximumCents
    ? cents
    : null;
}
